import { BarChart3, MousePointerClick, Eye, Store, LayoutGrid, Percent } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useMarketingAudit } from '@/hooks/use-marketing';

const METRICS = [
  { key: 'impressions', icon: Eye },
  { key: 'clicks', icon: MousePointerClick },
  { key: 'ctr', icon: BarChart3 },
  { key: 'storeOpens', icon: Store },
  { key: 'categoryOpens', icon: LayoutGrid },
  { key: 'conversion', icon: Percent },
];

export default function AdminMarketingSettings() {
  const { t, i18n } = useTranslation();
  const locale = ({ uz: 'uz-UZ', ru: 'ru-RU', en: 'en-US' } as Record<string, string>)[(i18n.language || 'uz').slice(0, 2)] ?? 'uz-UZ';
  const { data: audit = [] } = useMarketingAudit(undefined, undefined, { adminView: true });

  return (
    <div className="mx-auto max-w-7xl animate-fade-in p-6">
      <h1 className="mb-1 text-xl font-semibold text-foreground">{t('mkt_settings.title')}</h1>
      <p className="mb-5 text-sm text-muted-foreground">{t('mkt_settings.subtitle')}</p>

      <div className="mb-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {METRICS.map((m) => (
          <div key={m.key} className="rounded-xl border border-border bg-card p-4">
            <div className="mb-2 flex items-center gap-2 text-muted-foreground">
              <m.icon size={16} />
              <span className="text-xs">{t(`mkt_settings.metric_${m.key}`)}</span>
            </div>
            <p className="text-2xl font-semibold text-muted-foreground">—</p>
            <p className="mt-1 text-xs text-muted-foreground">{t('mkt_settings.noData')}</p>
          </div>
        ))}
      </div>

      <div className="rounded-xl border border-border bg-card">
        <div className="border-b border-border p-4">
          <h2 className="text-sm font-medium text-foreground">{t('mkt_settings.audit')}</h2>
        </div>
        {audit.length === 0 ? (
          <p className="p-6 text-center text-sm text-muted-foreground">{t('mkt_settings.auditEmpty')}</p>
        ) : (
          <div className="divide-y divide-border">
            {(audit as any[]).slice(0, 50).map((a) => (
              <div key={a.id} className="p-3">
                <p className="text-sm text-foreground">{a.action}</p>
                <p className="text-xs text-muted-foreground">
                  {a.entity_type} · {a.actor_role || '—'} · {new Date(a.created_at).toLocaleString(locale)}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
